import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimgs from "../../../assets/abacusLeftImg.png";
import rightimgs from "../../../assets/abacusRightImg.png";
import CourseStructureImg from "../../../assets/CourseStructureImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import BenefitsDataImg1 from "../../../assets/BenefitsDataImg1.png";
import BenefitsDataImg2 from "../../../assets/BenefitsDataImg2.png";
import BenefitsDataImg3 from "../../../assets/BenefitsDataImg3.png";
import BenefitsDataImg4 from "../../../assets/BenefitsDataImg4.png";
import BenefitsDataImg5 from "../../../assets/BenefitsDataImg5.png";
import BenefitsDataImg6 from "../../../assets/BenefitsDataImg6.png";
import BenefitsDataImg7 from "../../../assets/BenefitsDataImg7.png";
import BenefitsDataImg8 from "../../../assets/BenefitsDataImg8.png";
import BenefitsDataImg9 from "../../../assets/BenefitsDataImg9.png";
import Highlights from "../../../MyComponents/Highlights";
import AbacusHighlightImg1 from "../../../assets/AbacusHighlightImg1.png";
import AbacusHighlightImg2 from "../../../assets/AbacusHighlightImg2.png";
import AbacusHighlightImg3 from "../../../assets/AbacusHighlightImg3.png";
import AbacusHighlightImg4 from "../../../assets/AbacusHighlightImg4.png";
import AbacusHighlightImg5 from "../../../assets/AbacusHighlightImg5.png";
import AbacusHighlightImg6 from "../../../assets/AbacusHighlightImg6.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import sampleVideo from "../../../assets/sample-video.mp4";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
const BrainTrainAbacusJuniorPortal = () => {
  const BrainTrainAbacusPage = heroContent.BrainTrainAbacusPage;

  const foundationModules = [
    {
      title: "Module 1",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to Abacus, rules, and basic addition & subtraction up to 99.",
    },
    {
      title: "Module 2",
      duration: "3 Months",
      classes: "12",
      description: "Addition and subtraction of numbers up to 999.",
    },
  ];

  const beginnerModules = [
    {
      title: "Module 3",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to multiplication (2-digit × 1-digit) and advanced addition & subtraction.",
    },
    {
      title: "Module 4",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to division and multiplication of 3-digit numbers with continued addition & subtraction.",
    },
    {
      title: "Module 5",
      duration: "3 Months",
      classes: "12",
      description:
        "Introduction to decimals, division up to 4-digit ÷ 2-digit, and 2-digit × 2-digit multiplication.",
    },
  ];

  const benefitsData = [
    {
      title: "Whole Brain Development",
      description: "Activates both brain hemispheres for mental growth.",
      icon: "Polymath-images/BenefitsDataImg1.png",
    },
    {
      title: "Enhance Visual & Auditory Skills",
      description: "Sharpens listening and strengthens visual memory.",
      icon: "Polymath-images/BenefitsDataImg2.png",
    },
    {
      title: "Enhance Visual & Auditory Skills",
      description: "Improves pattern recognition and logical reasoning.",
      icon: "Polymath-images/BenefitsDataImg3.png",
    },
    {
      title: "Proficiency In Math",
      description: "Builds strong mental arithmetic and number fluency.",
      icon: "Polymath-images/BenefitsDataImg4.png",
    },
    {
      title: "Develops Speed & Accuracy",
      description: "Trains quick thinking while minimizing mistakes.",
      icon: "Polymath-images/BenefitsDataImg5.png",
    },
    {
      title: "Supports Dyslexia & Dyscalculia",
      description:
        "Inclusive, structured techniques that aid special learners.",
      icon: "Polymath-images/BenefitsDataImg6.png",
    },
    {
      title: "Personality Development",
      description: "Improves focus, discipline, and personal growth.",
      icon: "Polymath-images/BenefitsDataImg7.png",
    },
    {
      title: "Sharpens Cognitive Skills",
      description: "Enhances focus, attention span, and brain agility.",
      icon: "Polymath-images/BenefitsDataImg8.png",
    },
    {
      title: "Improves Observation",
      description: "Boosts memory retention and sharpens observation.",
      icon: "Polymath-images/BenefitsDataImg9.png",
    },
  ];

  const highlightsData = [
    {
      title: "Structure Curriculum",
      icon: "Polymath-images/AbacusHighlightImg1.png",
    },
    {
      title: "Skill Tracking",
      icon: "Polymath-images/AbacusHighlightImg2.png",
    },
    {
      title: "Brain Training Games",
      icon: "Polymath-images/AbacusHighlightImg3.png",
    },
    {
      title: "Certificates of Completion",
      icon: "Polymath-images/AbacusHighlightImg4.png",
    },
    {
      title: "Live Teacher Support",
      icon: "Polymath-images/AbacusHighlightImg5.png",
    },
    {
      title: "Practice Drills",
      icon: "Polymath-images/AbacusHighlightImg6.png",
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "https://www.youtube.com/embed/dM4HHtgy_wY",
  };

  return (
    <>
      <HeadSection
      leftImg={'Polymath-images/abacusLeftImg.png'}
      rightImg={'Polymath-images/abacusRightImg.png'}
      titlePart1="Brain Train Abacus"
      titlePart2="Unlocking Your Child's Brain Potential"
      description="At POLYMATH-KIDS, we don't just teach arithmetic - we develop concentration, ideation, and confidence. Our unique approach activates both hemispheres of the brain and encourages smart, fast, calculator-free calculations"
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        imageSrc={CourseStructureImg}
        title="Foundation Level Course"
        modules={foundationModules}
        timelinecolor="#CB1D5A"
      />
      <CourseTimeline
        title="Beginners Level Course"
        modules={beginnerModules}
        timelinecolor="#339BD6"
      />
      <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
      <Highlights
        title="Abacus Portal Highlights"
        highlightsData={highlightsData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default BrainTrainAbacusJuniorPortal;
